import React from "react";

export const FETCH_PENDING = "FETCH_PENDING";
export const FETCH_SUCCESS = "FETCH_SUCCESS";
export const FETCH_ERROR = "FETCH_ERROR";
export const SAVING_PENDING = "SAVING_PENDING";
export const SAVING_SUCCESS = "SAVING_SUCCESS";
export const SAVING_ERROR = "SAVING_ERROR";
export const SAVING_CANCEL = "SAVING_CANCEL";
export const SET_CHANGES = "SET_CHANGES";
export const SET_EDIT_ROW_KEY = "SET_EDIT_ROW_KEY";

type dispatchType = React.Dispatch<{ type: any; payload?: any }>;

export async function loadData(dispatch: dispatchType, getData: () => Promise<any>) {
  dispatch({ type: FETCH_PENDING });

  try {
    const data = await getData();

    dispatch({
      type: FETCH_SUCCESS,
      payload: {
        data,
      },
    });
  } catch (err) {
    dispatch({ type: FETCH_ERROR });
    throw err;
  }
}

export interface SaveChangeResult {
  data: any;
  keyExpr: string | Array<string>;
}

export async function saveChange(
  dispatch: dispatchType,
  change: { type: any; data: any; key: any },
  sendChange: (change: { type: any; data: any; key: any }) => Promise<SaveChangeResult>,
) {
  if (change && change.type) {
    dispatch({ type: SAVING_PENDING });
    try {
      const data = await sendChange(change);
      change.data = data.data;
      dispatch({
        type: SAVING_SUCCESS,
        payload: { change, keyExpr: data.keyExpr },
      });
      return;
    } catch (err) {
      dispatch({ type: SAVING_ERROR });
      throw err;
    }
  } else {
    dispatch({ type: SAVING_CANCEL });
    return;
  }
}

export function setChanges(dispatch: dispatchType, changes: any) {
  dispatch({
    type: SET_CHANGES,
    payload: changes,
  });
}

export function setEditRowKey(dispatch: dispatchType, editRowKey: any) {
  dispatch({
    type: SET_EDIT_ROW_KEY,
    payload: editRowKey,
  });
}
